document.addEventListener('DOMContentLoaded', function () {
  var checkbox  = document.getElementById('return-policy-consent');
  var error     = document.getElementById('consent-error');
  var cartForm  = document.getElementById('cart');
  var extraBtns = document.getElementById('additional-checkout-wrapper');
  var policyBox = document.querySelector('#cart-consent-wrapper > div');

  if (!checkbox) return;

  var STORAGE_KEY = 'mb_policy_agreed';
  var ONE_WEEK    = 7 * 24 * 60 * 60 * 1000;

  function updateExpressButtons() {
    if (extraBtns) {
      extraBtns.style.display = checkbox.checked ? 'block' : 'none';
    }
  }

  function hasAgreedRecently() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return false;
      var data = JSON.parse(stored);
      return (Date.now() - data.timestamp) < ONE_WEEK;
    } catch (e) {
      return false;
    }
  }

  function saveAgreement() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ timestamp: Date.now() }));
    } catch (e) {}
  }

  // If they agreed recently, hide the policy box and pre-check the checkbox
  if (hasAgreedRecently()) {
    checkbox.checked = true;
    var label = document.getElementById('consent-label');
    if (label) { label.style.opacity = '1'; label.style.cursor = 'pointer'; }
    var hint = document.getElementById('scroll-hint');
    if (hint) hint.style.display = 'none';
    updateExpressButtons();
  } else {
    // Disable checkbox until they scroll to the bottom
    checkbox.disabled = true;
    checkbox.style.opacity = '0.3';
    checkbox.style.cursor  = 'not-allowed';

    if (policyBox) {
      policyBox.addEventListener('scroll', function () {
        var distanceFromBottom = policyBox.scrollHeight - policyBox.scrollTop - policyBox.clientHeight;
        if (distanceFromBottom < 10) {
          checkbox.disabled = false;
          checkbox.style.opacity = '1';
          checkbox.style.cursor  = 'pointer';
          var label = document.getElementById('consent-label');
          if (label) { label.style.opacity = '1'; label.style.cursor = 'pointer'; }
          var hint = document.getElementById('scroll-hint');
          if (hint) hint.style.display = 'none';
        }
      });
    }
  }

  checkbox.addEventListener('change', function () {
    if (this.checked) {
      error.style.display = 'none';
      saveAgreement();
    }
    updateExpressButtons();
  });

  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        error.style.display = 'block';
        checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }
});